import { v7 as uuidv7 } from "uuid";
import { z } from "zod";
import { buildingSchema } from "./building";
import { buildingShiftRowSchema } from "./buildingShiftRow";

export const buildingShiftSchema = z.object({
  id: z.string().brand("buildingShiftId"),
  buildingShiftRowId: buildingShiftRowSchema.shape.id,
  year: z.number(),
  month: z.number(),
  day: z.number(),
  staffCount: z.number(),
  buildingId: buildingSchema.shape.id.nullish(),
});

export type BuildingShift = z.infer<typeof buildingShiftSchema>;

export type BuildingShiftInput = z.input<typeof buildingShiftSchema>;

export const newBuildingShift = (input: BuildingShiftInput): BuildingShift => buildingShiftSchema.parse(input);

export const createBuildingShift = (input: Omit<BuildingShiftInput, "id">): BuildingShift =>
  newBuildingShift({ ...input, id: uuidv7() });
